import { cx } from '@emotion/css';
import { CrossIcon } from '@snapchat/snap-design-system-icons';
import type { FC, PropsWithChildren } from 'react';
import { useState } from 'react';

import type { BackgroundColor } from '../../constants';
import { MotifComponent, MotifScheme, useMotifStyles } from '../../motif';
import { dataSetToAttributes, getBackgroundClassName } from '../../utils';
import {
  globalHeaderBannerButtonDivCss,
  globalHeaderBannerButtonStylesCss,
  globalHeaderBannerContentContainerCss,
  globalHeaderBannerCss,
} from './Banner.styles';

interface BannerProps extends PropsWithChildren {
  className?: string;
  contentClassName?: string;
  motifScheme?: MotifScheme;
  /** @deprecated Use motifScheme instead. */
  backgroundColor?: BackgroundColor;
  dataset?: DOMStringMap;
}

export const Banner: FC<BannerProps> = ({
  motifScheme,
  backgroundColor,
  className,
  children,
  contentClassName,
  dataset,
}) => {
  useMotifStyles(MotifComponent.BANNER);
  const [show, setShow] = useState(true);

  if (!show) {
    return null;
  }

  // Create fallback chain here instead of default parameters otherwise if 'motifScheme' is not provided,
  // the default background color will be used instead of falling back to the 'backgroundColor' parameter
  const motifSchemeWithFallback =
    motifScheme ?? (getBackgroundClassName(backgroundColor) as MotifScheme) ?? MotifScheme.DEFAULT;

  return (
    <div
      className={cx(
        MotifComponent.BANNER,
        globalHeaderBannerCss,
        className,
        motifSchemeWithFallback
      )}
      {...dataSetToAttributes(dataset)}
    >
      <div className={cx(globalHeaderBannerContentContainerCss, contentClassName)}>{children}</div>
      <div className={globalHeaderBannerButtonDivCss}>
        <button className={globalHeaderBannerButtonStylesCss} onClick={() => setShow(false)}>
          <CrossIcon size={24} />
        </button>
      </div>
    </div>
  );
};
